(function (window) {
  'use strict';

  var M2_TO_FT2 = 10.76391041671;
  var STANDARD_CEILING_M = 2.4;
  var STANDARD_CEILING_FT = 8;
  var MAX_CEILING_M = 4;
  var MAX_CEILING_FT = 13;

  var THRESHOLDS_M2 = [12, 50, 75, 100, 150, 200];
  var THRESHOLDS_FT2 = THRESHOLDS_M2.map(function (t) { return t * M2_TO_FT2; });

  var BUNDLE_DISCOUNT_2_CENTS = { aud: 12500, usd: 8800 };
  var BUNDLE_DISCOUNT_3_CENTS = { aud: 25000, usd: 17600 };

  var TIER_SPECS = {
    ecoLite: { ideal: 'Bedrooms, studies, small living areas' },
    plus: { ideal: 'Living rooms, open plan kitchens' },
    max: { ideal: 'Large open-plan spaces, commercial' }
  };

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findVariantByTitle(title, variants) {
    var searchTitle = title.toLowerCase().trim();
    return variants.find(function (variant) {
      var variantTitle = variant.title.toLowerCase().trim();
      return variantTitle === searchTitle || variantTitle.includes(searchTitle);
    });
  }

  function resolveTierKey(variantTitle) {
    var t = variantTitle.toLowerCase();
    if ((t.indexOf('eco') !== -1 && t.indexOf('lite') !== -1) || t.indexOf('eco-lite') !== -1) return 'ecoLite';
    if (t.indexOf('plus') !== -1) return 'plus';
    if (t.indexOf('max') !== -1) return 'max';
    return 'plus';
  }

  function formatPrice(cents, currencyCode) {
    var n = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '$' + Math.round(n).toLocaleString();
    }
  }

  function getBundleDiscountCents(quantity, isUS) {
    if (quantity >= 3) return isUS ? BUNDLE_DISCOUNT_3_CENTS.usd : BUNDLE_DISCOUNT_3_CENTS.aud;
    if (quantity >= 2) return isUS ? BUNDLE_DISCOUNT_2_CENTS.usd : BUNDLE_DISCOUNT_2_CENTS.aud;
    return 0;
  }

  function computeItemTotalCents(variant, quantity, isUS) {
    var subtotal = variant.price * quantity;
    var discount = getBundleDiscountCents(quantity, isUS);
    return Math.max(0, subtotal - discount);
  }

  function computeRoomSize(length, width, height, isUS) {
    var divisor = isUS ? STANDARD_CEILING_FT : STANDARD_CEILING_M;
    return length * width * height / divisor;
  }

  function applyCeilingHeightLimit(slider, isUS) {
    if (!slider) return;
    var max = isUS ? MAX_CEILING_FT : MAX_CEILING_M;
    slider.max = String(max);
    if (parseFloat(slider.value) > max) {
      slider.value = String(max);
    }
  }

  function resolveVariantOption(modelTitle, quantity, variants) {
    var variant = findVariantByTitle(modelTitle, variants);
    if (!variant) return null;
    return { variant: variant, quantity: quantity };
  }

  function getRecommendations(roomSize, productData, isUS) {
    var thresholds = isUS ? THRESHOLDS_FT2 : THRESHOLDS_M2;
    var variants = productData.variants;

    if (roomSize >= thresholds[5]) {
      return { type: 'contact' };
    }

    var options = [];

    if (roomSize < thresholds[0]) {
      options.push({ model: 'Eco-Lite', quantity: 1 });
      options.push({ model: 'Plus', quantity: 1 });
    } else if (roomSize < thresholds[1]) {
      options.push({ model: 'Plus', quantity: 1 });
    } else if (roomSize < thresholds[2]) {
      options.push({ model: 'Plus', quantity: 2 });
      options.push({ model: 'Max', quantity: 1 });
    } else if (roomSize < thresholds[3]) {
      options.push({ model: 'Plus', quantity: 3 });
      options.push({ model: 'Max', quantity: 1 });
    } else {
      options.push({ model: 'Plus', quantity: 3 });
      options.push({ model: 'Max', quantity: 2 });
    }

    var items = options
      .map(function (opt) { return resolveVariantOption(opt.model, opt.quantity, variants); })
      .filter(Boolean);

    if (!items.length) {
      return { type: 'variants', items: [] };
    }

    return { type: 'variants', items: items };
  }

  function formatDisplayTitle(variantTitle, quantity) {
    if (quantity > 1) {
      return quantity + ' \u00d7 ' + variantTitle;
    }
    return variantTitle;
  }

  function renderRoomSizeLine(dims, isUS) {
    var floorArea = dims.length * dims.width;
    var volume = floorArea * dims.height;
    var sizeStr = escapeHtml(String(Math.round(floorArea)));
    var volumeStr = escapeHtml(String(Math.round(volume)));
    var unit = isUS ? 'ft\u00b2' : 'm\u00b2';
    var volumeUnit = isUS ? 'ft\u00b3' : 'm\u00b3';
    return (
      '<p class="results-volume calculator-result-modal__volume">' +
      'Room size <strong><strong>' + sizeStr + '</strong> ' + unit + '</strong>' +
      ' \u00b7 Volume <strong><strong>' + volumeStr + '</strong> ' + volumeUnit + '</strong>' +
      '</p>'
    );
  }

  function renderContactMessage() {
    return (
      '<div class="calculator-result-modal__contact">' +
        '<p class="calculator-result-modal__contact-text">' +
          'Your space may require a tailored setup. Contact our team and we\u2019ll help recommend the best AirRepair setup for your room.' +
        '</p>' +
        '<button type="button" class="button button--primary has-arrow calculator-result-modal__contact-cta">' +
          '<span class="button-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.12575 0.000228269L3.12575 1.75063L10.1274 1.75063L2.98282e-05 11.878L1.25032 13.1282L11.3776 3.00092L11.3776 10.0025L13.128 10.0025L13.128 0.000229281L3.12575 0.000228269Z" fill="white"/></svg></span>' +
          'Contact us' +
        '</button>' +
      '</div>'
    );
  }

  function openHeaderNumbersPanel() {
    var phoneTrigger = document.getElementById('HeaderPhoneNumberLabel');
    if (!phoneTrigger) return false;

    var root = phoneTrigger.closest('.header-numbers');
    if (!root) return false;

    var panel = document.getElementById('HeaderNumbersPanel') || root.querySelector('.dropdown-phone-numbers');
    if (!panel) return false;

    document.querySelectorAll('.header-numbers.is-open').forEach(function (otherRoot) {
      if (otherRoot === root) return;
      otherRoot.classList.remove('is-open');
      var otherTrigger = otherRoot.querySelector('.header-numbers__trigger');
      var otherPanel = otherRoot.querySelector('.dropdown-phone-numbers');
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      if (otherPanel) {
        otherPanel.classList.remove('is-closing');
        otherPanel.setAttribute('aria-hidden', 'true');
      }
    });

    panel.classList.remove('is-closing');
    root.classList.add('is-open');
    phoneTrigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    return true;
  }

  function handleContactCtaClick(e, onClose) {
    var contactBtn = e.target.closest('.calculator-result-modal__contact-cta');
    if (!contactBtn) return false;

    e.preventDefault();
    e.stopPropagation();

    if (typeof onClose === 'function') onClose();

    window.requestAnimationFrame(function () {
      openHeaderNumbersPanel();
    });

    return true;
  }

  function renderResultCard(item, isFirstCard, productData, config, options) {
    options = options || {};
    var forPdp = !!options.forPdp;
    var variant = item.variant;
    var quantity = item.quantity || 1;
    var tierKey = resolveTierKey(variant.title);
    var spec = TIER_SPECS[tierKey] || TIER_SPECS.plus;
    var idealLine = escapeHtml(spec.ideal);
    var displayTitle = formatDisplayTitle(variant.title, quantity);
    var variantTitle = escapeHtml(displayTitle);
    var baseVariantTitle = escapeHtml(variant.title);
    var productUrl = variant.url + '#product-option-' + productData.id;
    var totalPrice = computeItemTotalCents(variant, quantity, config.isUS);
    var priceStr = escapeHtml(formatPrice(totalPrice, config.currencyCode));
    var imgSrc = variant.featured_image ? escapeHtml(variant.featured_image) : '';
    var imgTag = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + variantTitle + '" class="calculator-result-modal__thumb" width="120" height="120" loading="lazy">'
      : '';
    var ctaIcon =
      '<span class="button-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.12575 0.000228269L3.12575 1.75063L10.1274 1.75063L2.98282e-05 11.878L1.25032 13.1282L11.3776 3.00092L11.3776 10.0025L13.128 10.0025L13.128 0.000229281L3.12575 0.000228269Z" fill="white"/></svg></span>';
    var titleAttr = '';
    if (isFirstCard) {
      titleAttr = forPdp ? ' id="pdp-calculator-result-title"' : ' id="calculator-result-modal-title"';
    }
    var cta;

    if (forPdp) {
      var disabled = variant.available ? '' : ' disabled';
      var disabledClass = variant.available ? '' : ' calculator-result-modal__cta--disabled';
      cta =
        '<button type="button" class="button button--primary has-arrow calculator-result-modal__cta pdp-size-calculator__use-variant' + disabledClass + '" data-variant-id="' + variant.id + '"' + disabled + '>' +
        ctaIcon + 'Use ' + baseVariantTitle + '</button>';
    } else if (variant.available) {
      cta =
        '<a href="' + escapeHtml(productUrl) + '" class="button button--primary has-arrow calculator-result-modal__cta">' +
        ctaIcon + 'Use ' + baseVariantTitle + '</a>';
    } else {
      cta =
        '<button type="button" class="button button--primary has-arrow calculator-result-modal__cta calculator-result-modal__cta--disabled" disabled>' +
        ctaIcon + 'Out of Stock</button>';
    }

    return (
      '<div class="calculator-result-modal__card">' +
        '<div class="calculator-result-modal__row">' +
          imgTag +
          '<div class="calculator-result-modal__info">' +
            '<div class="calculator-result-modal__name"' + titleAttr + '>' + variantTitle + '</div>' +
            '<div class="calculator-result-modal__ideal">' + idealLine + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="calculator-result-modal__footer">' +
          cta +
          '<div class="calculator-result-modal__price-col">' +
            '<div class="calculator-result-modal__price">' + priceStr + '</div>' +
            '<div class="calculator-result-modal__price-note">One-time</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderOrDivider() {
    return '<div class="calculator-result-modal__or">OR</div>';
  }

  function renderCalculatorResults(recommendations, dims, productData, config, options) {
    options = options || {};
    var sizeLine = renderRoomSizeLine(dims, config.isUS);

    if (recommendations.type === 'contact') {
      return (
        '<div class="calculator-result-modal__stack">' +
          sizeLine +
          renderContactMessage() +
        '</div>'
      );
    }

    var cardsHtml = recommendations.items.reduce(function (html, item, index) {
      if (index > 0) html += renderOrDivider();
      return html + renderResultCard(item, index === 0, productData, config, options);
    }, '');

    return (
      '<div class="calculator-result-modal__stack">' +
        sizeLine +
        '<div class="calculator-result-modal__or">Recommended</div>' +
        '<div class="calculator-result-modal__cards">' + cardsHtml + '</div>' +
      '</div>'
    );
  }

  function renderPdpCalculatorResults(recommendations, dims, productData, config) {
    if (recommendations.type === 'contact') {
      return renderCalculatorResults(recommendations, dims, productData, config, { forPdp: true });
    }
    if (!recommendations.items.length) {
      return '<div class="pdp-size-calculator__empty">No matching model found for this room size.</div>';
    }
    return renderCalculatorResults(recommendations, dims, productData, config, { forPdp: true });
  }

  function bindSlider(slider, valueEl, decimals) {
    if (!slider || !valueEl) return;

    function sync() {
      valueEl.textContent = parseFloat(slider.value).toFixed(decimals);
    }

    slider.addEventListener('input', sync);
    sync();
  }

  function initSection(root, config, options) {
    if (!root || !config || !config.productData) return;

    options = options || {};
    var idPrefix = options.idPrefix || '';
    var forPdp = !!options.forPdp;
    var popup = !!options.popup;

    function el(id) {
      return root.querySelector('#' + idPrefix + id);
    }

    function showFormView() {
      var formView = el('calculator-form-view');
      var resultView = el('calculator-result-view');
      if (formView) formView.hidden = false;
      if (resultView) resultView.hidden = true;
    }

    function showResultView() {
      var formView = el('calculator-form-view');
      var resultView = el('calculator-result-view');
      if (formView) formView.hidden = true;
      if (resultView) resultView.hidden = false;
    }

    function openPopup() {
      var wrap = el('calculator-popup');
      if (!wrap) return;
      showFormView();
      wrap.hidden = false;
      wrap.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-size-calculator-open');
    }

    function closePopup() {
      var wrap = el('calculator-popup');
      if (!wrap) return;
      wrap.hidden = true;
      wrap.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-size-calculator-open');
    }

    function closeCalculatorResultModal() {
      var wrap = el('calculator-results');
      if (!wrap) return;
      wrap.style.display = 'none';
      wrap.setAttribute('aria-hidden', 'true');
    }

    function revealResults() {
      if (popup) {
        showResultView();
        return;
      }
      var wrap = el('calculator-results');
      if (wrap) {
        wrap.style.display = 'block';
        wrap.setAttribute('aria-hidden', 'false');
      }
      var closeBtn = el('calculator-result-modal-close');
      if (closeBtn) closeBtn.focus();
    }

    function calculateRoom() {
      var length = parseFloat(el('room-length').value);
      var width = parseFloat(el('room-width').value);
      var height = parseFloat(el('room-height').value);
      var minValue = config.isUS ? 3 : 1;
      var unit = config.isUS ? 'ft' : 'm';

      if (isNaN(length) || isNaN(width) || isNaN(height) || length < minValue || width < minValue || height < minValue) {
        window.alert('Please enter valid dimensions (all values must be at least ' + minValue + unit + ')');
        return;
      }

      var dims = { length: length, width: width, height: height };
      var roomSize = computeRoomSize(length, width, height, config.isUS);
      var recommendations = getRecommendations(roomSize, config.productData, config.isUS);
      var modalBody = el('calculator-result-modal-body');

      if (recommendations.type === 'variants' && !recommendations.items.length) {
        if (forPdp && modalBody) {
          modalBody.innerHTML = renderPdpCalculatorResults(recommendations, dims, config.productData, config);
          revealResults();
          return;
        }
        window.alert('No matching variants found. Please check the product variants.');
        return;
      }

      if (modalBody) {
        modalBody.innerHTML = forPdp
          ? renderPdpCalculatorResults(recommendations, dims, config.productData, config)
          : renderCalculatorResults(recommendations, dims, config.productData, config);
      }

      revealResults();
    }

    bindSlider(el('room-length'), el('length-value'), 1);
    bindSlider(el('room-width'), el('width-value'), 1);
    applyCeilingHeightLimit(el('room-height'), config.isUS);
    bindSlider(el('room-height'), el('height-value'), 1);

    var calculateBtn = el('calculate-btn');
    if (calculateBtn) calculateBtn.addEventListener('click', calculateRoom);

    if (popup) {
      var openBtn = el('calculator-open');
      var popupClose = el('calculator-popup-close');
      var popupOverlay = el('calculator-popup-overlay');

      if (openBtn) openBtn.addEventListener('click', openPopup);
      if (popupClose) popupClose.addEventListener('click', closePopup);
      if (popupOverlay) {
        popupOverlay.addEventListener('click', function (e) {
          if (e.target === popupOverlay) closePopup();
        });
      }
    } else {
      var modalOverlay = el('calculator-result-modal-overlay');
      var modalClose = el('calculator-result-modal-close');

      if (modalOverlay) {
        modalOverlay.addEventListener('click', function (e) {
          if (e.target === modalOverlay) closeCalculatorResultModal();
        });
      }
      if (modalClose) modalClose.addEventListener('click', closeCalculatorResultModal);
    }

    if (forPdp) {
      root.addEventListener('click', function (e) {
        var useBtn = e.target.closest('.pdp-size-calculator__use-variant');
        if (!useBtn || useBtn.disabled) return;
        var variantId = useBtn.getAttribute('data-variant-id');
        if (selectPdpVariant(variantId)) {
          if (popup) {
            closePopup();
          } else {
            closeCalculatorResultModal();
          }
        }
      });
    }

    root.addEventListener('click', function (e) {
      handleContactCtaClick(e, function () {
        if (popup) {
          closePopup();
        } else {
          closeCalculatorResultModal();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (popup) {
        var popupWrap = el('calculator-popup');
        if (popupWrap && !popupWrap.hidden) closePopup();
        return;
      }
      var wrap = el('calculator-results');
      if (wrap && wrap.style.display !== 'none') closeCalculatorResultModal();
    });
  }

  function selectPdpVariant(variantId) {
    var radio = document.querySelector('.pdp-main .product-form__radio[data-variant-id="' + variantId + '"]');
    if (!radio) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function initPdpModal(modal, config) {
    if (!modal || !config || !config.productData) return;

    var openTriggers = document.querySelectorAll('.pdp-size-calc-btn[data-pdp-calculator-open]');
    var lengthSlider = modal.querySelector('[data-pdp-calc-length]');
    var widthSlider = modal.querySelector('[data-pdp-calc-width]');
    var heightSlider = modal.querySelector('[data-pdp-calc-height]');
    var lengthValue = modal.querySelector('[data-pdp-calc-length-value]');
    var widthValue = modal.querySelector('[data-pdp-calc-width-value]');
    var heightValue = modal.querySelector('[data-pdp-calc-height-value]');
    var floorAreaValue = modal.querySelector('[data-pdp-calc-floor-area]');
    var floorAreaUnit = modal.querySelector('[data-pdp-calc-floor-unit]');
    var resultEl = modal.querySelector('[data-pdp-calc-result]');
    var closeEls = modal.querySelectorAll('[data-pdp-calc-close]');
    var areaUnit = config.isUS ? 'ft\u00b2' : 'm\u00b2';

    if (floorAreaUnit) floorAreaUnit.textContent = areaUnit;

    function getDimensions() {
      return {
        length: parseFloat(lengthSlider.value),
        width: parseFloat(widthSlider.value),
        height: parseFloat(heightSlider.value)
      };
    }

    function updateRecommendation() {
      var dims = getDimensions();
      var floorArea = dims.length * dims.width;
      var roomSize = computeRoomSize(dims.length, dims.width, dims.height, config.isUS);

      if (floorAreaValue) {
        floorAreaValue.textContent = config.isUS
          ? String(Math.round(floorArea))
          : (floorArea % 1 === 0 ? String(Math.round(floorArea)) : floorArea.toFixed(1));
      }

      var recommendations = getRecommendations(roomSize, config.productData, config.isUS);

      if (resultEl) {
        resultEl.innerHTML = renderPdpCalculatorResults(recommendations, dims, config.productData, config);
      }
    }

    function openModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-size-calculator-open');
      updateRecommendation();
      var closeBtn = modal.querySelector('.calculator-result-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-size-calculator-open');
    }

    bindSlider(lengthSlider, lengthValue, 1);
    bindSlider(widthSlider, widthValue, 1);
    applyCeilingHeightLimit(heightSlider, config.isUS);
    bindSlider(heightSlider, heightValue, 1);

    [lengthSlider, widthSlider, heightSlider].forEach(function (slider) {
      if (!slider) return;
      slider.addEventListener('input', updateRecommendation);
    });

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.classList.contains('calculator-result-modal__overlay') && e.target !== el) return;
        closeModal();
      });
    });

    modal.addEventListener('click', function (e) {
      if (handleContactCtaClick(e, closeModal)) return;
      var useBtn = e.target.closest('.pdp-size-calculator__use-variant');
      if (!useBtn || useBtn.disabled) return;
      var variantId = useBtn.getAttribute('data-variant-id');
      if (selectPdpVariant(variantId)) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function parseConfigFromScript(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function boot() {
    var sectionRoot = document.getElementById('room-calculator');
    var sectionConfig = parseConfigFromScript('room-calculator-config');
    if (sectionRoot && sectionConfig) initSection(sectionRoot, sectionConfig);

    var pdpRoot = document.getElementById('pdp-room-calculator');
    var pdpConfig = parseConfigFromScript('pdp-room-calculator-config');
    if (pdpRoot && pdpConfig) initSection(pdpRoot, pdpConfig, { idPrefix: 'pdp-', forPdp: true, popup: true });
  }

  window.AirRepairRoomCalculator = {
    initSection: initSection,
    initPdpModal: initPdpModal,
    getRecommendations: getRecommendations,
    computeRoomSize: computeRoomSize,
    computeItemTotalCents: computeItemTotalCents,
    getBundleDiscountCents: getBundleDiscountCents
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window);
